export const roleValues = {
  patientUserRole: "ce0e46d5-9031-4460-829e-ffeed1e26bfc"
};
